<div>
  <div class="action-block">
    <div class="action-item">
      <input [(ngModel)]="numberItem"/>
      <label>{{ 'event.numberOfCode' | translate }}</label>
    </div>
    <div class="action-item" (click)="downloadCode()">
      <img style="width: 70px" src="../../../../../assets/images/pdf.svg"/>
      <label>{{ 'event.downloadPdf' | translate }}</label>
    </div>
  </div>
</div>
